"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));
var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _react = _interopRequireDefault(require("react"));
var _propTypes = _interopRequireDefault(require("prop-types"));
var _isString = _interopRequireDefault(require("lodash/isString"));
var _trim = _interopRequireDefault(require("lodash/trim"));
var _styles = require("@material-ui/core/styles");
var _clsx4 = _interopRequireDefault(require("clsx"));
var _box = _interopRequireDefault(require("../box"));
var _count = _interopRequireDefault(require("../poly/count"));
var _reactMap = _interopRequireDefault(require("../poly/reactMap"));
var _excluded = ["children", "className", "isSubSection", "itemMargins"];
var useClasses = (0, _styles.makeStyles)(function (theme) {
  return {
    root: {
      display: 'flex',
      flexDirection: 'column',
      textAlign: 'left',
      width: '100%'
    },
    defaultItem: {
      marginTop: 0,
      marginBottom: 0
    },
    item: function item(_ref) {
      var _ref2;
      var itemMargins = _ref.itemMargins;
      return _ref2 = {
        marginTop: 0,
        marginBottom: itemMargins.mobile || '30px'
      }, (0, _defineProperty2.default)(_ref2, theme.breakpoints.up('sm'), {
        marginBottom: itemMargins.tablet || '30px'
      }), (0, _defineProperty2.default)(_ref2, theme.breakpoints.up('md'), {
        marginBottom: itemMargins.desktop || '50px'
      }), _ref2;
    },
    subSection: (0, _defineProperty2.default)({
      padding: 0
    }, theme.breakpoints.up('md'), {
      padding: 0
    })
  };
}, {
  classNamePrefix: 'TCUISection'
});
var Section = function Section(_ref3) {
  var children = _ref3.children,
    className = _ref3.className,
    isSubSection = _ref3.isSubSection,
    itemMargins = _ref3.itemMargins,
    rest = (0, _objectWithoutProperties2.default)(_ref3, _excluded);
  var _classes = useClasses({
    itemMargins: itemMargins
  });
  return /*#__PURE__*/_react.default.createElement(_box.default, (0, _extends2.default)({}, rest, {
    className: (0, _clsx4.default)(_classes.root, (0, _defineProperty2.default)({}, _classes.subSection, isSubSection), className)
  }), (0, _reactMap.default)(function (child, i, flattenedChildren) {
    if (!(0, _isString.default)(child)) {
      var _clsx2;
      return /*#__PURE__*/_react.default.cloneElement(child, {
        className: (0, _clsx4.default)(_classes.defaultItem, (_clsx2 = {}, (0, _defineProperty2.default)(_clsx2, _classes.item, i + 1 !== _react.default.Children.count(flattenedChildren)), (0, _defineProperty2.default)(_clsx2, _classes.subSection, child.type === Section), _clsx2), child.props.className)
      });
    }
    if ((0, _count.default)((0, _trim.default)(child)) > 0) {
      return /*#__PURE__*/_react.default.createElement("div", {
        className: (0, _clsx4.default)((0, _defineProperty2.default)({}, _classes.item, i + 1 !== _react.default.Children.count(flattenedChildren)))
      }, child);
    }
    return null;
  }, children));
};
Section.propTypes = {
  children: _propTypes.default.node,
  className: _propTypes.default.string,
  isSubSection: _propTypes.default.bool,
  itemMargins: _propTypes.default.shape({
    mobile: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
    tablet: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number]),
    desktop: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.number])
  })
};
Section.defaultProps = {
  children: null,
  className: null,
  isSubSection: false,
  itemMargins: {
    mobile: '30px',
    tablet: '30px',
    desktop: '50px'
  }
};
var _default = Section;
exports.default = _default;